/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Kno2Document } from './Kno2Document';
import {
    Kno2DocumentFromJSON,
    Kno2DocumentFromJSONTyped,
    Kno2DocumentToJSON,
} from './Kno2Document';

/**
 * 
 * @export
 * @interface GetDocuments200Response
 */
export interface GetDocuments200Response {
    /**
     * 
     * @type {Array<Kno2Document>}
     * @memberof GetDocuments200Response
     */
    data?: Array<Kno2Document>;
}

/**
 * Check if a given object implements the GetDocuments200Response interface.
 */
export function instanceOfGetDocuments200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetDocuments200ResponseFromJSON(json: any): GetDocuments200Response {
    return GetDocuments200ResponseFromJSONTyped(json, false);
}

export function GetDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocuments200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(Kno2DocumentFromJSON)),
    };
}

export function GetDocuments200ResponseToJSON(value?: GetDocuments200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(Kno2DocumentToJSON)),
    };
}

